/* Publish by EComposer at 2026-09-30 16:37:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7tquebtqvz9"]=  window.__ectimmers["ecom-7tquebtqvz9"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7tquebtqvz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tquebtqvz9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ci62lwx1ju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ci62lwx1ju', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-26ewqt66o7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26ewqt66o7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hs51nkxh8k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hs51nkxh8k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvc0nc3jpyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvc0nc3jpyn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttc6z7ivch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttc6z7ivch', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6mqsobul44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6mqsobul44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nmakhs8lb2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nmakhs8lb2b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ii2maailbel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ii2maailbel', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27jemea9hb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27jemea9hb8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cq10ru8bvlp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cq10ru8bvlp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jvnrdu3zbh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jvnrdu3zbh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kocs5hy25gg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kocs5hy25gg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tnjat7o29ni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnjat7o29ni', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wrvkq13fu48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wrvkq13fu48', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-356yi76c75o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-356yi76c75o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tw2asdne6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tw2asdne6d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gkncd5d0knh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gkncd5d0knh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7bcgwsmfy69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bcgwsmfy69', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hcusut8c9bv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hcusut8c9bv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpmrgmdmi4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpmrgmdmi4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0tmafi0x1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0tmafi0x1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q9ga4t4fkga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9ga4t4fkga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1dxkb30jj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1dxkb30jj6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ape23xqlj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ape23xqlj4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oujjxbt0dv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oujjxbt0dv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4i2vm3dfmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4i2vm3dfmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o611r2mnhuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o611r2mnhuh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c6a4m9b08ag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c6a4m9b08ag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-espdohk3pie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-espdohk3pie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itn35ljuxie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itn35ljuxie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ctra019f2gp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctra019f2gp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d32gf860grs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d32gf860grs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33xgfpvmkm4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33xgfpvmkm4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1j0tc6nbj6y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1j0tc6nbj6y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2a260hqw2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2a260hqw2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r152w3sz91').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r152w3sz91', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-isgs5o9dgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-isgs5o9dgb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p8376ql996g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8376ql996g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5mqv4786zj9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5mqv4786zj9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qkl1yp0hysc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkl1yp0hysc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h32dvhpagmv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h32dvhpagmv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wsr95iscmt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wsr95iscmt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1hw1yp4qa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1hw1yp4qa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zjj2n5q18xs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zjj2n5q18xs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sl0p4tt6cvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sl0p4tt6cvp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vixegnzuwu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vixegnzuwu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h86nwsad398').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h86nwsad398', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpciddt3svp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpciddt3svp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8n6sefy1by').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8n6sefy1by', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ps69hn26ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ps69hn26ff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tw4ods9xcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tw4ods9xcc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hit11kfpz1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hit11kfpz1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69nd430u7pq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69nd430u7pq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3c36eshqgg5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3c36eshqgg5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fp7a3vpozue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fp7a3vpozue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6xp0dalksm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6xp0dalksm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-akfkiti53o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-akfkiti53o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-duqdpr4h8cf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-duqdpr4h8cf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-usbpa8t8bpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-usbpa8t8bpf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdzpt68p439').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdzpt68p439', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0g68wb827c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0g68wb827c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sy4s6ts21gf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sy4s6ts21gf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1321weekytxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1321weekytxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pd1netmg03').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pd1netmg03', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-107wm8ocxk4a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-107wm8ocxk4a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4o0an6vk369').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4o0an6vk369', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uq5pf9thfum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uq5pf9thfum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nfgx93a148').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfgx93a148', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xtuemajyytn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xtuemajyytn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm3oo5hpvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm3oo5hpvb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9kasftkh8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9kasftkh8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufwoti0nt7d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufwoti0nt7d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv4ys14qe8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv4ys14qe8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b31vm3x1pwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b31vm3x1pwq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-76qklre6cnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-76qklre6cnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9py1fnur3q5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9py1fnur3q5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mb36vprpm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mb36vprpm8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6a7dd4zz2qt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6a7dd4zz2qt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6hinyybg0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6hinyybg0n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rowbk5l7zud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rowbk5l7zud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dkz3jso2qo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dkz3jso2qo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ti9z1bu0zc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ti9z1bu0zc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5mx0aljg6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5mx0aljg6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5mrfh5isk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5mrfh5isk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94u7a2r3cd5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94u7a2r3cd5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7p2cqwllljp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7p2cqwllljp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apvi9iut56m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apvi9iut56m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2eh3g0t5ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2eh3g0t5ei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f0d1fqd0cwo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f0d1fqd0cwo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4e6zg8he9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4e6zg8he9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37s3vws2zs1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37s3vws2zs1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jhye29r2du').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jhye29r2du', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rem7tcv5ny').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rem7tcv5ny', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8gcwa2c6vzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8gcwa2c6vzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzhnucd99fi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzhnucd99fi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fyohadb4go').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fyohadb4go', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ufutgypp24').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ufutgypp24', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jywj8d36kbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jywj8d36kbc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-agr39zqwdeh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-agr39zqwdeh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4u6326gkeo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4u6326gkeo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v6t7fdwzoc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6t7fdwzoc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ouvq6yojt6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ouvq6yojt6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kj481h5rjtj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kj481h5rjtj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uvo6srrdbh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uvo6srrdbh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wk7ypgoj1qb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wk7ypgoj1qb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aeh0hglri4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aeh0hglri4n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5brqaqjdc8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5brqaqjdc8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ja20hl9mvwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ja20hl9mvwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0epz5z8xmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0epz5z8xmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xg8o0krslt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xg8o0krslt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cm6pe7oglb5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cm6pe7oglb5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7f7pfqdx6k2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7f7pfqdx6k2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klg1pr9tp4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klg1pr9tp4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klh4sdvnqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klh4sdvnqc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mp911re27hg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mp911re27hg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn2rpi3fdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn2rpi3fdf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k3dvztjlg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k3dvztjlg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xh15537bv3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xh15537bv3p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0c1eyyskbqsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0c1eyyskbqsj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jgkcdwnhnwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jgkcdwnhnwk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jdgmae51l5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jdgmae51l5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30fm1prh1qy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30fm1prh1qy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ek8m1xi9jw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ek8m1xi9jw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqyxpxoivzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqyxpxoivzn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lkgk7mo1gnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lkgk7mo1gnk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b51fjhnqmpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b51fjhnqmpe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yepxkmw506p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yepxkmw506p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ixenmcjcew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixenmcjcew', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-om4oru4vjz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-om4oru4vjz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0zwrpz8ld9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0zwrpz8ld9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d55d75k9uur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d55d75k9uur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exfi2b223o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exfi2b223o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3m5e06w1ta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3m5e06w1ta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yxdesq66h3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yxdesq66h3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3o32s5b6wvk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3o32s5b6wvk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-og05g842o5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-og05g842o5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1j2dwlm9yri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1j2dwlm9yri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3z4bkros1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3z4bkros1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ws0smviixi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ws0smviixi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0b5z28olhcev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0b5z28olhcev', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7elpdwoamr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7elpdwoamr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98d24uialjk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98d24uialjk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpaxowqgugo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpaxowqgugo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j56lylnemvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j56lylnemvg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqmajy4vcv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqmajy4vcv8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgu6v60dbx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgu6v60dbx7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8lvwy33az6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8lvwy33az6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9i7of2ygvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9i7of2ygvb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4nmh9xoll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4nmh9xoll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im9qofo8yco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im9qofo8yco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xxzxkrl0cu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xxzxkrl0cu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pstzc5fobwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pstzc5fobwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kigms2ltfvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kigms2ltfvf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rc628cagxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rc628cagxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5djqax4xcjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5djqax4xcjo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nvmgrahpqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvmgrahpqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oj5k51hxq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oj5k51hxq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nj4bmschabg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nj4bmschabg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f48ukax6pw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f48ukax6pw8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nplhlx4o6jd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nplhlx4o6jd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9fywmh6qcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9fywmh6qcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bisviserxjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bisviserxjc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bkuxj96r31').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkuxj96r31', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exaognuwujl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exaognuwujl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f23igizhw19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f23igizhw19', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ao221qjwb8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ao221qjwb8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8sc3eqycp93').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8sc3eqycp93', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j15oc2fxya7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j15oc2fxya7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8thrsy41gwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8thrsy41gwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pu2owe2jl8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pu2owe2jl8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwu2imbxw7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwu2imbxw7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3dfqo9xxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3dfqo9xxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qtl0svfwku').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qtl0svfwku', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itzni696ptp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itzni696ptp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjzkyhqdoyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjzkyhqdoyu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogafxfnyjkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogafxfnyjkj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hw0krzbsm96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hw0krzbsm96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tevzwxqldf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tevzwxqldf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yirozbtvcbs"]=  window.__ectimmers["ecom-yirozbtvcbs"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-yirozbtvcbs"]["6ha9qzzys"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-yirozbtvcbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yirozbtvcbs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-adsogtgh937').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-adsogtgh937', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d57qkqjddy6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d57qkqjddy6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5wdeiux3s3x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5wdeiux3s3x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f5wtlx4w528').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5wtlx4w528', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d99pw943n79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d99pw943n79', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kjtv7zj85dg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kjtv7zj85dg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zr99uuadnqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zr99uuadnqa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ealw81nlc5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ealw81nlc5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrql8mza4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrql8mza4k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3lixf1qe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3lixf1qe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lehfhohrmpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lehfhohrmpn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54i9huelog2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54i9huelog2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9owljiz63lf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9owljiz63lf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmgtu5lyb0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmgtu5lyb0t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-if58bt8xu4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-if58bt8xu4q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pg4ybsbus4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pg4ybsbus4t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ksu4ywndbqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ksu4ywndbqr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zp66hb483h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zp66hb483h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v83wud9oj8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v83wud9oj8m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8i5ygrprp7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8i5ygrprp7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sxp9qzmi7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sxp9qzmi7h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrvhurr74vi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrvhurr74vi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6inqvbcb5rx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6inqvbcb5rx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-udd44cp4q0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-udd44cp4q0p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zkmhwyeddrc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zkmhwyeddrc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2bwd0vy0x9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2bwd0vy0x9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htbulazepi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htbulazepi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9h6eashucgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9h6eashucgo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hn3r3hz1pu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hn3r3hz1pu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8gy4uai49ie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8gy4uai49ie', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-himgndtjo8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-himgndtjo8v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ntby6pyatj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ntby6pyatj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ssdf16qp2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ssdf16qp2w', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zc5jdoqwey').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zc5jdoqwey', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pehncf9bzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pehncf9bzq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ezxduk6ldwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ezxduk6ldwd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kq3goujv4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kq3goujv4t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pcvdjy5ttr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pcvdjy5ttr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izmnw05o3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izmnw05o3l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rqe0o2fcnc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqe0o2fcnc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ikee0fedx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ikee0fedx9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qcasymgr4fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qcasymgr4fa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snzlhtz25br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snzlhtz25br', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6p3trshvawq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6p3trshvawq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fttlweiyb7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fttlweiyb7g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7uyuup1nh2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7uyuup1nh2n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0jh0ifxofe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0jh0ifxofe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khgknbnea6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khgknbnea6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9anxmszunn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9anxmszunn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztrdn6g1m1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztrdn6g1m1l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53go4yxilln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53go4yxilln', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hj1p4zaqs64').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hj1p4zaqs64', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6xnrwj7kbxe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6xnrwj7kbxe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-865fz2vd2y6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-865fz2vd2y6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27y50i9htlb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27y50i9htlb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ao5gph042yn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ao5gph042yn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l08ns8katd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l08ns8katd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0tfoj4vy2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0tfoj4vy2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xaj6e86ha8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xaj6e86ha8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7a4p78qd2n8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7a4p78qd2n8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjntq0m375o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjntq0m375o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x2ca31sts5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x2ca31sts5l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lyo6ip5893q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lyo6ip5893q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l37vxbcyqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l37vxbcyqz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53apphbg266').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53apphbg266', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8l7kxhqx3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8l7kxhqx3e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8klwvaorom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8klwvaorom', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnxu6hxr1hf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnxu6hxr1hf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zuxl0ngdpx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zuxl0ngdpx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5u7iun3gci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5u7iun3gci', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09tln19g0qk3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09tln19g0qk3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hddevvdhsvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hddevvdhsvs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7q922kwvwym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7q922kwvwym', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ledqqmggus').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ledqqmggus', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nkd3le3avij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nkd3le3avij', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ux6lgp90gl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ux6lgp90gl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfuh3s6pyvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfuh3s6pyvs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oov6yh5zlyt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oov6yh5zlyt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fkwvk2m514').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fkwvk2m514', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ocqssz1j39').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ocqssz1j39', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qglgsh23gp"]=  window.__ectimmers["ecom-qglgsh23gp"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-qglgsh23gp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qglgsh23gp', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j124pe1e9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j124pe1e9f', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dimuvrbpsun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dimuvrbpsun', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8zd2nhlkvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8zd2nhlkvo', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g0816vluvm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g0816vluvm', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uxiuos98vir"]=  window.__ectimmers["ecom-uxiuos98vir"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const o=document.querySelectorAll(".ecom-container-lightbox-"+e);o.length&&o.forEach(function(s){const r=s.querySelector("iframe");r!=null&&(r.contentWindow.postMessage('{"method":"pause"}',"*"),r.src="");const a=s.querySelector("video");a!=null&&a.pause()})};if(t&&window.EComModal){var n=t.querySelector("[ecom-modal]");new window.EComModal(n,{cssClass:["ecom-container-lightbox-"+this.id,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const o=document.querySelectorAll(".ecom-container-lightbox-"+e);o.length&&(o.forEach(function(s){const r=s.querySelector("iframe");if(r!=null){const l=r.src.replace("muted=1","muted=0").replace("mute=1","mute=0");r.src=l}const a=s.querySelector("video");a!=null&&a.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:o}})))},onClose:i})}i()

                    });
                    
                        document.querySelectorAll('.ecom-uxiuos98vir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxiuos98vir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpnraudfm2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpnraudfm2m', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cex1pk3l9g6"]=  window.__ectimmers["ecom-cex1pk3l9g6"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-cex1pk3l9g6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cex1pk3l9g6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yba4cowepvn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yba4cowepvn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xda89ijq7oa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xda89ijq7oa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-038lly37eykg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-038lly37eykg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lnugq9po47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lnugq9po47', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8s9n5dx08xi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8s9n5dx08xi', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4pg63gcga5x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4pg63gcga5x', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zofe1pfiwbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zofe1pfiwbg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7isz706b6ca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7isz706b6ca', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4btilcmt2jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4btilcmt2jp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xla4bvocdhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xla4bvocdhn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5szop8t54f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5szop8t54f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zu51r262b2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zu51r262b2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2nczt92yh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2nczt92yh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kpx89mbwas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kpx89mbwas', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-daon4chwo2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-daon4chwo2s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i28tl94143').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i28tl94143', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0co35at6jwk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0co35at6jwk5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kh4r6gz48og').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kh4r6gz48og', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51c0f4y184g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51c0f4y184g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c5vjd8juxip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c5vjd8juxip', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f4rnust04g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f4rnust04g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h68s1dhlnw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h68s1dhlnw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jpx907dbzwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jpx907dbzwr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46adsssltq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46adsssltq3', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kh9ski750em').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kh9ski750em', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-63vx91ca70j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-63vx91ca70j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bbfxwo91j1j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bbfxwo91j1j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4j2efe1hk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4j2efe1hk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7fwmff88vf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7fwmff88vf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlovag3q4sn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlovag3q4sn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpa58jn38n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpa58jn38n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clnq0sx3rqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clnq0sx3rqj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izrcq5lzz1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izrcq5lzz1f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5istm7uz8vx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5istm7uz8vx', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cvvopga99n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cvvopga99n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3m95n8pfinw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3m95n8pfinw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bgm1liln48c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bgm1liln48c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pyqjwdj4jtl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pyqjwdj4jtl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqtvzp5y9nd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqtvzp5y9nd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9wklu2mih1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9wklu2mih1p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-furhvo4030d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-furhvo4030d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1e9api0n2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1e9api0n2n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xrovtb6082r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xrovtb6082r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7lfcxjvldk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7lfcxjvldk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7gj2tyq8dm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7gj2tyq8dm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46r4dog8mtt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46r4dog8mtt', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4kaw9yajn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4kaw9yajn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dizdo6q5a76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dizdo6q5a76', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g9irubuano').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g9irubuano', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufbx9noilom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufbx9noilom', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}